import fetchObject from './fetchObject';
import fetchCollection from './fetchCollection';
import fetchCollection2 from './fetchCollection2';
import loadCollection from './loadCollection';

const functions = {
  fetchObject,
  fetchCollection,
  fetchCollection2,
  loadCollection,
};

export default functions;
